<template>
  <div>
    <v-row>
      <v-col style="padding:0px;padding-right:-12px;padding-bottom:12px" cols="12" class="d-flex pl-0 justify-end">
        <v-btn color="primary" @click="onCreate()"><i class="fas fa-plus mr-1"></i> Add chapter</v-btn>
      </v-col>
      <v-col cols="12" class="elevation-1">
        <v-data-table
          :headers="columns"
          :items="chapters"
          :hide-default-footer="false"
          :hide-default-header="false"
          disable-pagination
        >
          <template v-slot:[`item.title`]="{ item }">
            <v-avatar tile size="40" color="#dddd" class="text-center pointer mr-3">
              <img
                :src="
                  item.imageSrc ? imageHelpers.url(item.imageSrc) : imageHelpers.url('@/assets/images/no-image.png')
                "
                alt=""
                srcset=""
              />
            </v-avatar>
            <span>{{ utilities.stringLimit(item.title, 40) }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon @click="onEdit(item._id)"><i class="fas fa-edit"></i></v-btn>
            <v-btn icon @click="onDelete(item._id)"><i class="fas fa-trash"></i></v-btn>
          </template>
        </v-data-table>
      </v-col>
      <!-- <v-col cols="1" class="d-flex pl-0">
        <v-btn color="primary" @click="onCreate()"><i class="fas fa-plus"></i></v-btn>
      </v-col> -->
    </v-row>
    <ChapterModal ref="modal" :book="book" :onSaved="loadData" />
    <delete-action :content="`Chapter`" :title="`Delete`" />
  </div>
</template>

<script>
import utilities from '@/helpers/utilities';
import imageHelpers from '@/helpers/image';
import { imageFake } from '@/const/image';
import { bookApi } from '@/apis/book';
import ChapterModal from './ChapterModal';

export default {
  components: { ChapterModal },
  props: ['book'],
  data() {
    return {
      imageHelpers,
      utilities,
      imageFake,
      showDialogDelete: false,
      idItem: '',
      chapters: [],
      columns: [
        { text: 'TITLE', value: 'title' },
        { text: 'FROM PAGE', value: 'fromPageNumber' },
        { text: 'TO PAGE', value: 'toPageNumber' },
        { align: 'right', value: 'actions' },
      ],
    };
  },
  methods: {
    async loadData() {
      try {
        let res = await bookApi.getChapters(this.book);
        this.chapters = res.data.chapters;
      } catch (err) {
        this.chapters = [];
      }
    },
    onCreate() {
      this.$refs.modal.show({
        title: '',
        fromPageNumber: 0,
        toPageNumber: 0,
        description: '',
        code: '',
        image: '',
        imageSrc: '',
      });
    },
    onDelete(item) {
      this.idItem = item;
      this.showDialogDelete = true;
    },
    async submitDelete() {
      try {
        await bookApi.deleteChapter(this.$route.params.id, this.idItem);
        await this.loadData();
        this.showDialogDelete = false;
      } catch (error) {
        console.log(error);
      }
    },
    onEdit(id) {
      this.$refs.modal.show(id);
    },
  },
  created() {
    this.loadData();
  },
};
</script>
